import { notifyAlert, notifyFailure, notifySuccess } from 'app/Notifications/actions';

import { addExperimentVariants } from './actions';
import normalizer from './normalizer';

/**
 * thunk to fetch experiment data
 * @param {string} experimentName - experiment name for lookup
 * @returns {Function} thunk
 */
export const fetchExperiment = experimentName => async (dispatch, _, { api }) => {
  dispatch(notifyAlert(`Searching for experiment ${experimentName}`));
  try {
    const { experiments = [] } = await api.experiments.findExperiment(experimentName);
    const experimentResult = experiments
      .map(normalizer)
      .find(exp => exp.name === experimentName);

    if (!experimentResult) {
      const msg = `No variants found for '${experimentName}'. Please double check Experiments Creator!`;
      throw new Error(msg);
    }

    dispatch(addExperimentVariants(experimentResult));
    dispatch(notifySuccess(`Variants found for experiment ${experimentName}`));
  } catch (error) {
    dispatch(notifyFailure(error.message));
  }
};
